import EditDomain from './EditDomain';

export default EditDomain;
